import {
  GenderEnum,
  PassengerIdentifierTypeEnum,
} from 'api-hooks/common/model';
import regex from 'constant/regex';
import { Translate } from 'next-translate';
import * as Yup from 'yup';
export const registerFormType = (t: Translate) =>
  Yup.object({
    name: Yup.string().required().default(''),
    gender: Yup.string().nullable().required().default(GenderEnum.Male),
    identifierType: Yup.string().nullable().required(),
    identifierCode: Yup.string()
      .nullable()
      .default(null)
      .required()
      .when('identifierType', {
        is: PassengerIdentifierTypeEnum.NationalId,
        then: (schema) =>
          schema.matches(regex.nik, t('common:invalid_identity_code')),
      })
      .when('identifierType', {
        is: PassengerIdentifierTypeEnum.Passport,
        then: (schema) =>
          schema.matches(regex.passport, t('common:invalid_identity_code')),
      })
      .when('identifierType', {
        is: PassengerIdentifierTypeEnum.DriverLicense,
        then: (schema) =>
          schema.matches(regex.sim, t('common:invalid_identity_code')),
      })
      .when('identifierType', {
        is: PassengerIdentifierTypeEnum.FamilyCard,
        then: (schema) =>
          schema.matches(regex.nikk, t('common:invalid_identity_code')),
      }),
    email: Yup.string().email().required().default(''),
    password: Yup.string().min(8).required().default(''),
    passwordConfirmation: Yup.string()
      .oneOf(
        [Yup.ref('password'), undefined],
        t('common:password_confirmation_must_match'),
      )
      .required()
      .default(''),
    verificationToken: Yup.string().default(''),
  });

export type RegisterFormType = Yup.InferType<
  ReturnType<typeof registerFormType>
>;
